var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVLo3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 86,
    viewBox: "0 0 92 86",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prima-Versione",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0 0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ANTICIPO-TFS---DOCUMENTI",
    transform: "translate(-1087 -1458)",
    stroke: "#FCBB00",
    strokeWidth: 4.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "v_lo_3",
    transform: "translate(1090 1461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.296457,45.3143738 L45.296457,75.2077321 C45.296457,79.6086987 50.7768606,81.6846276 53.6831594,78.3631432 L85.1127354,42.6571889 C87.8529601,39.5432973 85.6524969,34.6856262 81.5006414,34.6856262 L68.6714234,34.6856262 L68.6714234,4.79226538 C68.6714234,0.39129886 63.1908931,-1.68462923 60.2845943,1.63685517 L28.8551444,37.3428111 C26.1564384,40.4567027 28.3569015,45.3143738 32.4672385,45.3143738 L45.296457,45.3143738 Z",
    id: "Vector",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.063 6.785L0 6.785M24.911 73.215L0 73.215M12.456 40L0 40"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVLo3);
export default __webpack_public_path__ + "static/media/v_lo_3.8dbca4b08cc73afe368e5ab12214f283.svg";
export { ForwardRef as ReactComponent };